export default __webpack_public_path__ + "static/media/manual-download-result.9469681e.png";